<template>
	<footer class="footer">
		<div class="wrap footer-top footer-wrap">
			<div class="footer-info">
				<div class="footer-brand">{{ site.companyName || '合肥中科厚生医疗科技有限公司' }}</div>
				<p>电话：{{ site.phone }}</p>
				<p>邮箱：{{ site.email }}</p>
				<p>地址：{{ site.address }}</p>
			</div>
			<div class="footer-nav">
				<router-link v-for="nav in navs" :key="nav.id" :to="nav.path">{{ nav.title }}</router-link>
			</div>
			<div class="footer-qr">
				<img v-if="site.wechatOfficialQr" :src="site.wechatOfficialQr" alt="微信公众号" />
				<div v-else class="qr-empty">
					<span>微信公众号</span>
				</div>
				<p>扫码关注公众号</p>
			</div>
		</div>
		<div class="copyright">
			<p>COPYRIGHT © 2026 {{ site.companyName || '合肥中科厚生医疗科技有限公司' }}</p>
			<div class="beian-links">
				<a v-if="site.icp" href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">{{ site.icp || '皖ICP备2026022881号' }}</a>
				<img src="../../public/static/beian-icon.png" alt="" class="beian-icon" /><a href="https://beian.mps.gov.cn/#/query/webSearch?code=34012302001402" target="_blank"
					rel="noopener">{{ site.psbFiling || '皖公网安备34012302001402号' }}</a>
				<span>{{ site.medicalBeian || '皖网药械信备字〔2026〕000115号' }}</span>
			</div>
		</div>
	</footer>
</template>

<script>
	export default {
		props: {
			site: Object,
			navs: Array
		}
	}
</script>
<style scoped>
	.beian-icon{
		width: 15px;
		margin-right: -14px;
	}
</style>